import { type ReactNode } from 'react';

import { replaceSlashedZero } from '../../core/typographyStyles.sty.js';
import { InnerHandler } from '../types/pie-chart.config.js';

/**
 * Total value slot component for donut chart.
 */
export const DonutChartInner = ({
  children,
}: {
  children: InnerHandler | ReactNode;
  // TODO: Strict mode
  // eslint-disable-next-line @typescript-eslint/prefer-ts-expect-error, @typescript-eslint/ban-ts-comment
  //@ts-ignore Strict mode transition - needs to be investigated
}) => <div className={replaceSlashedZero}>({children})</div>;

DonutChartInner['displayName'] = 'DonutChart.Inner';
